import { LuPlus, LuX } from 'react-icons/lu'

import { ModalBase } from '@/lib/core/components/Modal/ModalBase'

import { AlertSeverity } from '../../constants/alertContract'
import { AlertSeverityBadge } from '../AlertSeverityBadge'
import { AlertCard } from './AlertCard'
import { AlertFilterPanel } from './AlertFilterPanel'
import { useManageAlertsModal } from './useManageAlertsModal'
import styles from './ManageAlertsModal.module.css'

export const ManageAlertsModal = () => {
  const {
    isManageAlertsOpen,
    closeManageAlerts,
    openCreateAlert,
    openDeleteAlert,
    filters,
    setFilters,
    openMenuId,
    setOpenMenuId,
    menuRef,
    filtered,
    handleToggleAlert,
    handleEditAlert,
  } = useManageAlertsModal()

  return (
    <ModalBase
      isActive={isManageAlertsOpen}
      onEscape={closeManageAlerts}
      dataTestId="manage-alerts-modal"
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.headerTitle}>Alerts</span>
          <button
            className={styles.closeButton}
            type="button"
            onClick={closeManageAlerts}
            data-testid="manage-alerts-close"
          >
            <LuX size={20} />
          </button>
        </div>

        <div className={styles.toolbar}>
          <div className={styles.toolbarLeft}>
            <button
              className={styles.addButton}
              type="button"
              onClick={openCreateAlert}
              data-testid="manage-alerts-add"
            >
              <LuPlus size={16} />
              Add New Alert
            </button>
          </div>
          <AlertFilterPanel filters={filters} onChange={setFilters} />
        </div>

        <div className={styles.body}>
          <div className={styles.grid}>
            {filtered.map((alert) => (
              <AlertCard
                key={alert.id}
                alert={alert}
                isMenuOpen={openMenuId === alert.id}
                menuRef={menuRef}
                onToggle={handleToggleAlert}
                onEdit={handleEditAlert}
                onDelete={openDeleteAlert}
                onToggleMenu={setOpenMenuId}
              />
            ))}
          </div>
        </div>

        <div className={styles.footer}>
          <div className={styles.legend}>
            <span className={styles.legendLabel}>Key</span>
            <AlertSeverityBadge severity={AlertSeverity.URGENT} />
            <AlertSeverityBadge severity={AlertSeverity.SUCCESS} />
            <AlertSeverityBadge severity={AlertSeverity.WARNING} />
            <AlertSeverityBadge severity={AlertSeverity.INFO} />
          </div>
          <span>
            1 – {filtered.length} of {filtered.length}
          </span>
        </div>
      </div>
    </ModalBase>
  )
}
